const consultationTypes = [
  {
    name: "Онлайн-консультация",
    price: "3000",
    currency: "руб.",
    duration: "50 минут",
  },
  {
    name: "Консультация в офисе в Москве",
    price: "3700",
    currency: "руб.",
    duration: "50 минут",
  },
  {
    name: "Онлайн-сессия ДПДГ",
    price: "3000",
    currency: "руб.",
    duration: "50 минут",
  },
  {
    name: "Очная сессия ДПДГ в офисе в Москве",
    price: "3700",
    currency: "руб.",
    duration: "50 минут",
  },
  {
    name: "Семейная онлайн-консультация",
    price: "5000",
    currency: "руб.",
    duration: "80 минут",
  },
  {
    name: "Семейная консультация в офисе в Москве",
    price: "6000",
    currency: "руб.",
    duration: "80 минут",
  },
]

export default Object.freeze({
  data: consultationTypes,
 });
